import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment';
import { dateHelper, errorHandler } from '../common';
import { reportsRepo } from './reportsRepo';

/*
 reportDatesDialog

 This component represents the report dates dialog.

 */

ko.components.register('reportDatesDialog', {
    viewModel: reportDatesDialog,
    template: {
        element: 'report-dates-dialog-template'
    }
});


export function reportDatesDialog(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof reportDatesDialog)
        return data;

    let endPeriod;
    let startPeriod;

    self.element = ko.observable(null);
    self.loadingData = ko.observable(false);
    self.defaultFiscalStartDateKeys = { FiscalYear: "", FiscalQuarter: "", FiscalPeriod: "", FiscalWeek: "" };
    self.dateProperties = ko.observable({
        dateRangeType: ko.observable("Last"),
        dateIntervalAmount: ko.observable(3),
        dateIntervalType: ko.observable("Week")
    });
    self.dateProperties().specificStartDate = ko.observable('');
    self.dateProperties().specificEndDate = ko.observable('');
    self.dateProperties().fiscalStartDatePeriod = ko.observable(0);
    self.dateProperties().fiscalStartDateYear = ko.observable(0);
    self.dateProperties().fiscalEndDatePeriod = ko.observable(0);
    self.dateProperties().fiscalEndDateYear = ko.observable(0);
    self.dateRangeTypes = ko.observableArray([{ text: "Current", value: "Current" }, { text: "Last", value: "Last" }, { text: "Last Complete", value: "LastComplete" }, { text: "Fiscal Range", value: "FiscalRange" }, { text: "Specific Dates", value: "SpecificDates" }])
    self.dateIntervalTypes = ko.observableArray([
        { text: "Day", value: "Day" },
        { text: "Week", value: "Week" },
        { text: "Month", value: "Month" },
        { text: "Quarter", value: "Quarter" },
        { text: "Year", value: "Year" },
        { text: "Fiscal Year", value: "FiscalYear" },
        { text: "Fiscal Quarter", value: "FiscalQuarter" },
        { text: "Fiscal Period", value: "FiscalPeriod" },
        { text: "Fiscal Week", value: "FiscalWeek" },
        { text: "Day Close Date", value: "DayCloseDate" }
    ]);
    self.dateIntervalTypesPlural = ko.observableArray([{ text: "Days", value: "Day" }, { text: "Weeks", value: "Week" }, { text: "Months", value: "Month" }, { text: "Quarters", value: "Quarter" }, { text: "Years", value: "Year" }, { text: "Fiscal Years", value: "FiscalYear" }, { text: "Fiscal Quarters", value: "FiscalQuarter" }, { text: "Fiscal Periods", value: "FiscalPeriod" }, { text: "Fiscal Weeks", value: "FiscalWeek" }]);
    self.dateIntervalTypesFiscalOnly = ko.observableArray([{ text: "Fiscal Year", value: "FiscalYear" }, { text: "Fiscal Quarter", value: "FiscalQuarter" }, { text: "Fiscal Period", value: "FiscalPeriod" }, { text: "Fiscal Week", value: "FiscalWeek" }]);
    self.showDateIntervalTypesPlural = ko.computed(function () {

        var range = self.dateProperties().dateRangeType();
        var amount = self.dateProperties().dateIntervalAmount();

        if (range === 'Current' || range === 'FiscalRange')
            return false;

        if (amount === 1)
            return false;

        return true;
    });
    self.reportDateRangeText = ko.computed(function () {

        var range = self.dateProperties().dateRangeType();
        var intervalAmount = _.toNumber(self.dateProperties().dateIntervalAmount());
        var interval = self.dateProperties().dateIntervalType() === null ? "Day" : self.dateProperties().dateIntervalType();
        interval = intervalAmount === 1 || range === "Current" ? interval : interval + "s";

        if (range === "Current") {
            return "Current " + interval;
        }
        else if (range === "LastComplete") {
            return "Last " + intervalAmount.toString() + " Complete " + interval;
        }
        else if (range === "SpecificDates") {
            return "Specific Dates";
        }
        else if (range === "FiscalRange") {
            return "Fiscal Range";
        }
        else {
            return "Last " + intervalAmount.toString() + " " + interval;
        }
    });

    self.getDateRangeDataPromise = data.getDateRangeDataPromise;
    self.onCancelCallback = data.onCancelCallback;
    self.onApplyCallback = data.onApplyCallback;

    self.applyButtonClick = function (item, event) {

        var props = ko.mapping.toJS(self.dateProperties());

        //Translate date props to a date range string
        var dateRange = "Current-Week";

        if (props.dateRangeType === "Current") {
            //Current-Week
            dateRange = "Current-" + props.dateIntervalType;
        }
        else if (props.dateRangeType === "SpecificDates") {
            const from = document.getElementById('fromDatePicker').value;
            const to = document.getElementById('toDatePicker').value;

            //SpecificDates-01-01-2020-to-01-31-2020
            dateRange = "SpecificDates-" + from + "-to-" + to;
        }
        else if (props.dateRangeType === "FiscalRange") {
            //FiscalWeek-1-2020-to-2-2020

            const end = endPeriod.value;
            const start = startPeriod.value;

            props.fiscalStartDateYear = getFiscalYearFromFiscalDateKey(start);
            props.fiscalStartDatePeriod = getPeriodNumberFromFiscalDateKey(start);

            props.fiscalEndDateYear = getFiscalYearFromFiscalDateKey(end);
            props.fiscalEndDatePeriod = getPeriodNumberFromFiscalDateKey(end);

            if (props.fiscalStartDateYear && props.fiscalStartDatePeriod && props.fiscalEndDateYear && props.fiscalEndDatePeriod) {
                dateRange = props.dateIntervalType + "-" + props.fiscalStartDatePeriod + "-" + props.fiscalStartDateYear
                    + "-to-" + props.fiscalEndDatePeriod + "-" + props.fiscalEndDateYear;
            }
            else {
                dateRange = "Current-FiscalWeek";
            }

        }
        else if (props.dateRangeType === "Last" || props.dateRangeType === "LastComplete") {
            //Last-3-Week
            dateRange = props.dateRangeType + "-" + props.dateIntervalAmount + "-" + props.dateIntervalType;
        }

        if (!_.isNullOrUndefined(self.onApplyCallback)) {
            self.onApplyCallback(dateRange);
        }
    }

    self.cancelButtonClick = function (item, event) {

        if (!_.isNullOrUndefined(self.onCancelCallback)) {
            self.onCancelCallback();
        }
    }

    self.fiscalEndDateChanged = function () {
        const end = endPeriod.value;
        const start = startPeriod.value;

        //Make sure the ending date comes after the starting date
        var endFiscalYear = getFiscalYearFromFiscalDateKey(end);
        var endPeriodNumber = getPeriodNumberFromFiscalDateKey(end);
        var startFiscalYear = getFiscalYearFromFiscalDateKey(start);
        var startPeriodNumber = getPeriodNumberFromFiscalDateKey(start);
        if ((endFiscalYear < startFiscalYear) || (endFiscalYear == startFiscalYear && endPeriodNumber < startPeriodNumber)) {
            startPeriod.value = end;
        }

    }

    self.dateIntervalTypeChanged = async function (newValue, dataItem) {
        if (self.dateProperties().dateRangeType() === "FiscalRange") {
            await loadFiscalPeriods();
        }
    }

    self.dateRangeTypeChanged = async function (newValue, dataItem) {
        var dateIntervalAmount = 0;
        var dateIntervalType = null;
        var fiscalStartDatePeriod = 0;
        var fiscalEndDatePeriod = 0;
        var fiscalStartDateKey = "";
        var fiscalEndDateKey = "";

        if (newValue === "SpecificDates") {
            //do nothing
        }
        else if (newValue === "FiscalRange") {
            dateIntervalType = "FiscalYear";
            fiscalStartDateKey = self.defaultFiscalStartDateKeys.FiscalYear || "";
            fiscalEndDateKey = fiscalStartDateKey;
        }
        else {
            dateIntervalAmount = 3;
            dateIntervalType = "Week";
        }

        self.dateProperties().dateIntervalType(dateIntervalType);
        self.dateProperties().dateIntervalAmount(dateIntervalAmount);

        if (!self.dateProperties().fiscalStartDatePeriod)
            self.dateProperties().fiscalStartDatePeriod = ko.observable(0);

        if (!self.dateProperties().fiscalEndDatePeriod)
            self.dateProperties().fiscalEndDatePeriod = ko.observable(0);

        self.dateProperties().fiscalStartDatePeriod(fiscalStartDatePeriod);
        self.dateProperties().fiscalEndDatePeriod(fiscalEndDatePeriod);

        switch (newValue) {
            case 'FiscalRange':
                await loadFiscalPeriods();
                break;
        }

        startPeriod.value = fiscalStartDateKey;
        endPeriod.value = fiscalEndDateKey;
    }

    self.initializeDatePickers = function () {
        $("#fromDatePicker").empty();
        $("#toDatePicker").empty();

        //Create the date pickers
        $("#fromDatePicker").kendoDatePicker({
            format: "MM/dd/yyyy"
        });
        $("#toDatePicker").kendoDatePicker({
            format: "MM/dd/yyyy"
        });
    }

    var getFiscalDateKey = function (fiscalYear, periodNumber) {
        return fiscalYear + "|" + periodNumber;
    }

    var getFiscalYearFromFiscalDateKey = function (fiscalDateKey) {

        if (fiscalDateKey && fiscalDateKey.indexOf("|") > -1) {
            return fiscalDateKey.substring(0, fiscalDateKey.indexOf("|"));
            return fiscalDateKey.substring(fiscalDateKey.indexOf("|") + 1);
        }
        return null;
    }

    var getPeriodNumberFromFiscalDateKey = function (fiscalDateKey) {

        if (fiscalDateKey && fiscalDateKey.indexOf("|") > -1) {
            const period = fiscalDateKey.substring(fiscalDateKey.indexOf("|") + 1);

            return Number(period);
        }
        return null;
    }

    var init = async function () {

        //Call the promise functions to get report columns and all columns
        if (!_.isNullOrUndefined(self.getDateRangeDataPromise)) {

            self.loadingData(true);

            //Go get the report and columns data...
            //Get the data
            try {
                const [dateData, dateRange] = await Promise.all([
                    reportsRepo.getFiscalDateData.apply(null),
                    self.getDateRangeDataPromise.apply(null)]);

                //Set the default starting period keys to get our dropdowns to work
                self.defaultFiscalStartDateKeys.FiscalYear = getFiscalDateKey(dateData.fiscalYear, 1);
                self.defaultFiscalStartDateKeys.FiscalQuarter = getFiscalDateKey(dateData.fiscalYear, dateData.fiscalQuarter);
                self.defaultFiscalStartDateKeys.FiscalPeriod = getFiscalDateKey(dateData.fiscalYear, dateData.fiscalPeriod);
                self.defaultFiscalStartDateKeys.FiscalWeek = getFiscalDateKey(dateData.fiscalYear, dateData.fiscalWeek);

                //Translate date range to date properties
                var dateProperties = {};
                dateProperties.dateRangeType = dateRange.substring(0, dateRange.indexOf("-")); //Current, Last, LastComplete, SpecificDates, FiscalRange
                dateProperties.dateIntervalType = "Day"; //Day, Week, Month, Quarter, Year, FiscalWeek, FiscalPeriod, FiscalQuarter, FiscalYear
                dateProperties.specificStartDate = null;
                dateProperties.specificEndDate = null;
                dateProperties.fiscalStartDatePeriod = 0;
                dateProperties.fiscalStartDateYear = 0;
                dateProperties.fiscalEndDatePeriod = 0;
                dateProperties.fiscalEndDateYear = 0;

                if (dateProperties.dateRangeType === "Current") {
                    //Current-Week
                    dateProperties.dateIntervalAmount = 1;
                    dateProperties.dateIntervalType = dateRange.substring("Current-".length);
                }
                else if (dateProperties.dateRangeType === "SpecificDates") {
                    const shortDate = /^\d{2}\/\d{2}\/\d{4}$/;

                    //SpecificDates-01-01-2020-to-01-31-2020
                    dateProperties.dateIntervalAmount = 0;
                    dateProperties.dateIntervalType = "Day";
                    var datesPart = dateRange.substring("SpecificDates-".length);

                    const specificStartDate = datesPart.substring(0, datesPart.indexOf("-to-"));
                    const specificEndDate = datesPart.substring(datesPart.indexOf("-to-") + 4);

                    dateProperties.specificStartDate = shortDate.test(specificStartDate) ? specificStartDate : dateHelper.getShortDateString(specificStartDate);
                    dateProperties.specificEndDate = shortDate.test(specificEndDate) ? specificEndDate : dateHelper.getShortDateString(specificEndDate);
                }
                else if (dateProperties.dateRangeType.substring(0, 6) === "Fiscal") {
                    //FiscalWeek-1-2020-to-2-2020
                    dateProperties.dateIntervalAmount = 0;
                    dateProperties.dateIntervalType = dateProperties.dateRangeType;
                    dateProperties.dateRangeType = "FiscalRange";
                    var firstPeriod = dateRange.substring(dateRange.indexOf("-") + 1);
                    dateProperties.fiscalStartDatePeriod = parseInt(firstPeriod.substring(0, firstPeriod.indexOf("-")));
                    dateProperties.fiscalStartDateYear = parseInt(firstPeriod.substring(firstPeriod.indexOf("-") + 1));
                    var secondPeriod = dateRange.substring(dateRange.indexOf("-to-") + 4);
                    dateProperties.fiscalEndDatePeriod = parseInt(secondPeriod.substring(0, secondPeriod.indexOf("-")));
                    dateProperties.fiscalEndDateYear = parseInt(secondPeriod.substring(secondPeriod.indexOf("-") + 1));

                    await loadFiscalPeriods(dateProperties.dateIntervalType);

                    startPeriod.value = getFiscalDateKey(dateProperties.fiscalStartDateYear, dateProperties.fiscalStartDatePeriod);
                    endPeriod.value = getFiscalDateKey(dateProperties.fiscalEndDateYear, dateProperties.fiscalEndDatePeriod);
                }
                else if (dateProperties.dateRangeType === "Last" || dateProperties.dateRangeType === "LastComplete") {
                    //Last-3-Week
                    var restOfString = dateRange.substring((dateProperties.dateRangeType + "-").length);
                    dateProperties.dateIntervalAmount = parseInt(restOfString.substring(0, restOfString.indexOf("-")));
                    dateProperties.dateIntervalType = restOfString.substring(restOfString.indexOf("-") + 1);
                }

                //Set the report
                self.dateProperties(ko.mapping.fromJS(dateProperties));

                self.loadingData(false);

                //Subscribe to updates of the dateIntervalAmount
                self.dateProperties().dateIntervalAmount.subscribeChanged(function (newValue, oldValue) {

                    if (newValue.toString().indexOf(".") !== -1) {
                        //Don't allow entering a decimal point
                        newValue = newValue.toString().substring(0, newValue.toString().indexOf("."));
                        self.dateProperties().dateIntervalAmount(_.toNumber(newValue));
                    }
                    else if (!_.isInteger(_.toNumber(newValue))) {
                        //Don't allow entering any non-integer values
                        self.dateProperties().dateIntervalAmount(_.toNumber(oldValue));
                    }
                    else if (_.trim(newValue) === "") {
                        //Convert empty string to zero
                        self.dateProperties().dateIntervalAmount(0);
                    }
                });
            } catch (errorResult) {
                self.loadingData(false);
            }
        }
    }

    init();

    const elementSubscription = self.element.subscribe(() => {
        endPeriod = document.getElementById('end-period-dropdown');
        startPeriod = document.getElementById('start-period-dropdown');

        endPeriod.addEventListener('change', self.fiscalEndDateChanged);

        elementSubscription.dispose();
    });

    /**
     * Loads the fiscal periods of the specified interval type into the dialog.
     * 
     * @param {'FiscalPeriod' | 'FiscalQuarter' | 'FiscalWeek' | 'FiscalYear'} intervalType The type of fiscal interval
     * to load. Defaults to the dialog's current saved type.
     * 
     * @returns A promise that resolves when the periods have been loaded.
     */
    async function loadFiscalPeriods(intervalType = self.dateProperties().dateIntervalType()) {
        const loading = document.createElement('option');

        const now = moment();

        const selects = [endPeriod, startPeriod];

        let periodDateDiff = Number.MAX_SAFE_INTEGER;

        let periods;

        loading.textContent = 'Loading...';

        for (const select of selects) {
            select.disabled = true;

            select.textContent = '';

            select.add(loading.cloneNode(true));
        }

        try {
            periods = await reportsRepo.getAllFiscalPeriods(intervalType);
        } catch (error) {
            errorHandler.processResponse(error);

            return;
        }

        for (const select of selects) {
            select.textContent = '';
        }

        for (const period of periods) {
            const option = document.createElement('option');

            const value = period.fiscalYear + "|" + period.startingPeriodNumber;

            period.text = period.fiscalYear + (intervalType === "FiscalQuarter" ? " Quarter " + period.startingPeriodNumber :
                intervalType === "FiscalPeriod" ? " Period " + period.startingPeriodNumber :
                    intervalType === "FiscalWeek" ? " Week " + period.startingPeriodNumber : "") + " (" + moment(period.startDate).format("MM/DD/YYYY") + " - " + moment(period.endDate).format("MM/DD/YYYY") + ")";

            period.key = value;

            option.textContent = period.text;
            option.value = value;

            for (const select of selects) {
                select.disabled = false;

                select.add(option.cloneNode(true));
            }

            const diff = now.diff(moment(period.startDate), 'days');

            if (diff < periodDateDiff) {
                periodDateDiff = diff;

                for (const select of selects) {
                    select.value = value;
                }
            }
        }

        const defaultExists = periods.some(({ key }) => key === self.defaultFiscalStartDateKeys.FiscalPeriod);

        if (!defaultExists) {
            self.defaultFiscalStartDateKeys.FiscalPeriod = periods[periods.length - 1].key;
        }
    }
}
